'use client';

import {
  LOAD_BOARD_NEW_SEARCH_PAGE_PATH,
  LOAD_BOARD_PAGE_PATH,
} from '~/app/pages';
import { useLoadBoardLastQueryString } from './LoadBoardLastQueryStringProvider';
import NavLink from '~/app/(authenticated)/_ui/NavItems/NavLink';
import useIsActivePathname from '~/app/(authenticated)/_lib/useIsActivePath';

export default function LoadBoardNavLink() {
  const loadBoardQueryString = useLoadBoardLastQueryString();

  return (
    <NavLink
      href={
        loadBoardQueryString
          ? `${LOAD_BOARD_PAGE_PATH}?${loadBoardQueryString}`
          : LOAD_BOARD_NEW_SEARCH_PAGE_PATH
      }
      label="Load Board"
      active={useIsActivePathname(LOAD_BOARD_PAGE_PATH, {
        match: 'startsWith',
      })}
    />
  );
}
